import React, { useState, useEffect } from 'react';
import { pdfjs, Document, Page } from 'react-pdf';
import Loading from '@components/Loading';
import useStyles from './useStyles';
import { IconButton, TextField } from '@material-ui/core';
import { Printer, ChevronDown, ChevronUp } from '@carbon/icons-react';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

interface Props {
  fileUrl?: string;
  fileId?: string;
  fileName?: string;
}

const PDFViewer = ({ fileUrl, fileName, fileId }: Props) => {
  const classes = useStyles();
  const [total, setTotal] = useState(1);

  const [page, setPage] = useState(1);

  useEffect(() => {
    setPage(1);
    setTotal(1);
  }, [fileUrl]);

  const onNext = () => {
    setPage((prev) => {
      if (total === prev) {
        return prev;
      }

      return prev + 1;
    });
  };

  const onPrev = () => {
    setPage((prev) => {
      if (prev === 1) {
        return 1;
      }

      return prev - 1;
    });
  };

  return (
    <div className={classes.container}>
      <div className="block" />

      <div className={classes.root}>
        <div className={classes.toolbar}>
          <div className="up-down">
            <IconButton className="prev" onClick={onPrev}>
              <ChevronDown />
            </IconButton>
            <div className="pdf-page">
              <TextField
                variant="outlined"
                value={page}
                InputProps={{ readOnly: true }}
              />
              <span className="divider">/</span>
              <span className="total">{total}</span>
            </div>
            <IconButton className="next" onClick={onNext}>
              <ChevronUp />
            </IconButton>
          </div>

          <IconButton
            className="printer"
            onClick={() => {
              window.open(`${fileUrl}`);
            }}
          >
            <Printer />
          </IconButton>
        </div>
        <Document
          renderMode="svg"
          onLoadSuccess={(success) => setTotal(success.numPages)}
          options={{
            cMapUrl: `//cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/cmaps/`,
            cMapPacked: true
          }}
          file={`${fileUrl}`}
          loading={<Loading open={true} />}
          noData={
            <div className="loading">
              <h3>잘못된 파일입니다.</h3>
            </div>
          }
        >
          <Page pageNumber={page} renderMode="svg" renderTextLayer={false} />
        </Document>
      </div>

      <div className="block" />
    </div>
  );
};

export default PDFViewer;
